import Link from 'next/link';
import { Instagram, Facebook, Twitter, Phone } from 'lucide-react';
import Image from 'next/image';
import styles from './Footer.module.css';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Main Footer Content */}
                <div className={styles.grid}>
                    {/* Brand Column */}
                    <div className={styles.brand}>
                        <div className={styles.logo}>
                            <Image src="/logo-with-text.png" alt="Sirius Coffee Logo" width={140} height={50} sizes="140px" style={{ objectFit: 'contain', objectPosition: 'left center' }} />
                        </div>
                        <p className={styles.tagline}>
                            Lebanon&apos;s Capsule Coffee Hub. Premium flavors, fast delivery.
                            Experience the perfect shot.
                        </p>
                        <div className={styles.social}>
                            <a href="https://instagram.com/siriuscoffeelb" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <Instagram size={20} />
                            </a>
                            <a href="https://facebook.com/siriuscoffeelb" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <Facebook size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className={styles.links}>
                        <h4>Shop</h4>
                        <ul>
                            <li><Link href="/products">All Capsules</Link></li>
                            <li><Link href="/products?category=espresso">Espresso</Link></li>
                            <li><Link href="/products?category=flavored">Flavored</Link></li>
                            <li><Link href="/products?category=decaf">Decaf</Link></li>
                            <li><Link href="/blog">Blog</Link></li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div className={styles.links}>
                        <h4>Support</h4>
                        <ul>
                            <li><Link href="/about">About Us</Link></li>
                            <li><Link href="/contact">Contact</Link></li>
                            <li><Link href="/shipping">Shipping Info</Link></li>
                            <li><Link href="/privacy">Privacy Policy</Link></li>
                            <li><Link href="/terms">Terms of Service</Link></li>
                        </ul>
                    </div>

                    {/* Social & Contact */}
                    <div className={styles.links}>
                        <h4>Follow Us</h4>
                        <div className={styles.socialColumn}>
                            <a href="https://instagram.com/siriuscoffeelb" target="_blank" rel="noopener noreferrer" className={styles.socialItem} aria-label="Instagram">
                                <Instagram size={18} />
                                <span>Instagram</span>
                            </a>
                            <a href="https://facebook.com/siriuscoffeelb" target="_blank" rel="noopener noreferrer" className={styles.socialItem} aria-label="Facebook">
                                <Facebook size={18} />
                                <span>Facebook</span>
                            </a>
                            <a href="https://twitter.com/siriuscoffeelb" target="_blank" rel="noopener noreferrer" className={styles.socialItem} aria-label="Twitter/X">
                                <Twitter size={18} />
                                <span>Twitter / X</span>
                            </a>
                            <a href="tel:+96171280878" className={styles.socialItem} aria-label="Phone">
                                <Phone size={18} />
                                <span>+961 71 280 878</span>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className={styles.bottom}>
                    <p>&copy; {currentYear} Sirius Coffee. All rights reserved.</p>
                    <p className={styles.credit}>
                        Crafted with ☕ in Lebanon
                    </p>
                </div>
            </div>
        </footer>
    );
}
